import React, { useState } from "react";
import styles from "./signup.module.css";
import FormFields from "../../components/Form";
import { useNavigate } from "react-router-dom";
import Button from "common/Button";
import Toast, { allowOnlyAlphaAndSpace } from "utils";
import { postData } from "utils/queries";
import CheckBox from "common/CheckBox";

const SignUp = () => {
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search)
  const role = queryParameters.get("role") || "admin";
  const [userDetails, setUserDetails] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    role: role
  });

  const handleChange = (label) => {
    return (e) => {
      if(["first_name", "last_name"]?.includes(label)){
        e.target.value = allowOnlyAlphaAndSpace(e)
      }
      setUserDetails({ ...userDetails, [label]: e.target.value });
    };
  };

  const Fields = [
    {
      label: "First Name",
      id: "firstName",
      placeholder: "First Name",
      type: "text",
      maxLength:30,
      // pattern:"^[a-zA-Z0-9]+$",
      value: userDetails?.first_name,
      required: true,
      onChange: handleChange("first_name"),
    },
    {
      label: "Last Name",
      id: "last_name",
      placeholder: "Last Name",
      maxLength:30,
      type: "text",
      value: userDetails?.last_name,
      required: true,
      onChange: handleChange("last_name"),
    },
    {
      label: "Email",
      id: "email",
      placeholder: "Email",
      type: "email",
      maxLength:35,
      // pattern:"[A-Za-z0-9]+",
      value: userDetails?.email,
      required: true,
      onChange: handleChange("email"),
    },
    {
      label: "Password",
      id: "password",
      placeholder: "*******",
      type: "password",
      maxLength:35,
      value: userDetails?.password,
      required: true,
      onChange: handleChange("password"),
    },
  ];

  const handleSubmit = async (e) => {
    try{

    e.preventDefault();
   
    const response = await postData(`auth/signup`, {
      ...userDetails,
      role: role
    });
    console.log("response is", response)
    if(response?.data?.success){
      Toast().Success("Otp Sent to registered Email")
      navigate(`/otp-verification?email=${userDetails?.email}`)
    }else{
      // Toast().Error("")
    }
  } catch(error){
    Toast().Error(error?.response?.data?.message || error?.response?.data?.errors?.[0]?.msg)
  }

   


  };

  return (
    <div className={styles.container}>
      <h2 htmlFor="email" className={styles.signInLabel}>
        Register
      </h2>

      <div className={styles.formContainer}>
         <form onSubmit={handleSubmit}>
          <FormFields Fields={Fields} />

          <div className={styles.termsAndConditions}>
            <CheckBox label="" required={true} checkBoxClassOverride ={styles.checkBoxClassOverride } />
            <div className={styles.termsAndConditionsInfo}>
              By signing up you agree to Flow's
              <span className={styles.underline}> Terms & Conditions</span>
            </div>{" "}
          </div>
          <div className={styles.formGroup}>
            <Button
             label={"Confirm"}
             type="submit"
             buttonOverrideStyle={styles.button_}
            //  onClick={() => navigate("/home")}


            />
          </div>
        </form>
        <div className={styles?.divider}></div>
        <div className={styles.signup}>
          <div className={styles.signUpInfo}>Already have a Flow account ?</div>
          <button
            className={styles.registerButton}
            onClick={() => navigate("/")}
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
  
};

export default SignUp;
